// Progressive filters: all products remain visible and shoppable without JS.
(function () {
  function mount(root) {
    if (root.dataset.editBound) return;
    root.dataset.editBound = 'true';
    var cards = Array.from(root.querySelectorAll('[data-edit-card]'));
    var controls = root.querySelector('[data-edit-filters]');
    var count = root.querySelector('[data-edit-count]');
    if (controls) {
      var buttons = Array.from(controls.querySelectorAll('[data-edit-filter]'));
      buttons.forEach(function (button) {
        var category = button.dataset.editFilter;
        button.hidden = category !== 'all' && !cards.some(function (card) { return card.dataset.category === category; });
      });
      controls.hidden = false;
      controls.addEventListener('click', function (event) {
        var button = event.target.closest('[data-edit-filter]');
        if (!button || !controls.contains(button)) return;
        var category = button.dataset.editFilter, visible = 0;
        buttons.forEach(function (item) { item.setAttribute('aria-pressed', String(item === button)); });
        cards.forEach(function (card) {
          card.hidden = category !== 'all' && card.dataset.category !== category;
          if (!card.hidden) visible += 1;
        });
        count.textContent = visible + (visible === 1 ? ' piece' : ' pieces');
      });
    }
    // Keep campaign context when moving from the edit into product details.
    var source = new URLSearchParams(window.location.search);
    root.querySelectorAll('a[data-edit-product]').forEach(function (link) {
      var target = new URL(link.href, window.location.origin);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_content', 'utm_term'].forEach(function (key) {
        if (source.get(key)) target.searchParams.set(key, source.get(key));
      });
      link.href = target.pathname + target.search + target.hash;
    });
    // Preserve links used by the style quiz and the preceding landing page.
    if (window.location.hash === '#new-dresses') root.querySelector('#today-products').scrollIntoView();
  }
  document.querySelectorAll('[data-outfit-edit]').forEach(mount);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-outfit-edit]').forEach(mount);
  });
})();
